import { Business } from "./business.server";
import { AxiosRequestConfig } from "axios";
// tslint:disable:max-classes-per-file
// tslint:disable:ter-max-len

/**
 * 项目基础请求服务
 * @author 马俊峰
 * @date 2019-11-28
 * @export
 * @class BaseRequestServer
 * @extends {Business}
 */
export class BaseRequestServer extends Business {
  constructor() {
    super(`${window.config.publisher}/api/v1`);
  }
}

/**
 * 定义静态基础服务请求
 * @author 马俊峰
 * @date 2019-11-28
 * @export
 * @class BaseRequestStaticServer
 */
export class BaseRequestStaticServer {
  /** get请求 */
  static async get<T>(url: string, setting?: AxiosRequestConfig) {
    return new BaseRequestServer().get<T>(url, setting);
  }
  /** post请求 */
  static async post<T, P>(url: string, data: P, setting?: AxiosRequestConfig) {
    return new BaseRequestServer().post<T, P>(url, data, setting);
  }
  /** put请求 */
  static async put<T, P>(url: string, data: P, setting?: AxiosRequestConfig) {
    return new BaseRequestServer().put<T, P>(url, data, setting);
  }
  /** delete请求 */
  static async delete(url: string, setting ?: AxiosRequestConfig) {
    return new BaseRequestServer().delete(url, setting);
  }
}
